import React from "react";
import { Phone } from "lucide-react";
import { ICON_STROKE } from "../../ui/icon";
import { toTitleCase } from "../../../utils/titleCase";
import { localizeFieldName } from "../../../utils/fieldTypes";
import { useLanguage } from "../../../contexts/LanguageContext";
import { PremiumLinkedText } from "../../premium/PremiumFeatures";

const PublicDetailRows = ({ items, onCallNumber, t }) => {
  const { lang } = useLanguage();

  if (!items?.length) {
    return <p className="pub-detail-empty">{t("public.notAvailable")}</p>;
  }

  return (
    <div className="pub-detail-rows">
      {items.map((item, idx) => {
        const raw = (item.value || "").toString().replace(/\s/g, "").replace(/-/g, "");
        const isPhone = item.protectedPhone || /^[6-9]\d{9}$/.test(raw);
        const localized = localizeFieldName(item.key, lang);
        const label = lang === "hi" ? localized : toTitleCase(localized);

        if (item.locked) {
          return (
            <div key={idx} className="pub-detail-row pub-detail-row--locked">
              <span className="pub-detail-row__label">{label}</span>
              <span className="pub-detail-row__value">
                <PremiumLinkedText text={t("public.premiumFieldLocked")} />
              </span>
            </div>
          );
        }

        if (isPhone) {
          return (
            <div key={idx} className="pub-detail-row">
              <span className="pub-detail-row__label">{label}</span>
              <button
                type="button"
                className="pub-detail-row__call"
                onClick={() => onCallNumber?.({ id: item.id, name: label, number: raw || undefined })}
              >
                <Phone size={14} strokeWidth={ICON_STROKE} aria-hidden />
                {t("public.callNow")}
              </button>
            </div>
          );
        }

        const value = (item.value || "").trim() || t("public.notAvailable");
        return (
          <div key={idx} className="pub-detail-row">
            <span className="pub-detail-row__label">{label}</span>
            <span
              className={`pub-detail-row__value${value === t("public.notAvailable") ? " pub-detail-row__value--muted" : ""}`}
            >
              {value}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default PublicDetailRows;
